import React from 'react';
import { observable } from 'mobx';
import { notification } from 'antd';
import isMobile from 'ismobilejs';
import intl from 'react-intl-universal';
import Config from '../config';
import { tronscanTX } from '../utils/helper';
import Tip from '../components/Tip';
import { getTimeNow } from '../utils/backend';
import { getTrxBalance, getTransactionInfo } from '../utils/blockchain';
export default class NetworkStore {
  @observable tronWeb = false;
  @observable defaultAccount = null;
  @observable isConnected = null;
  @observable routeName = '';
  @observable lang = '';
  @observable loginModalVisible = false;
  @observable accountModalVisible = false;
  @observable loginModalStep = 1;
  @observable menuFlag = false; // true 为展开， false 为收起
  @observable start = null;
  @observable nowTime = null;
  @observable multyStart = true; // 20:30后
  @observable multyRealStart = true; // 21:00后
  @observable btcstStart = null; // 3-22 21:00后

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  getDescription = (type, item, text) => {
    // console.log('description type: ', type);
    const { tx, title, status } = item;
    let className = '';
    switch (type) {
      case 1:
        className = 'trans-pending';
        break;
      case 2:
        className = 'trans-confirmed';
        break;
      case 3:
        className = 'trans-failed';
        break;
    }
    return (
      <div className={'trans-notify'}>
        <span>{tronscanTX(intl.get('view_on_tronscan'), tx)}</span>
        {type === 3 ? (
          <Tip tip={intl.getHTML('toast.faild_reason')} left>
            <span className={'trans-btn-tip ' + className}>{text}</span>
          </Tip>
        ) : (
          <span className={'trans-btn-tip ' + className}>{text}</span>
        )}
      </div>
    );
  };

  checkPendingTransactions = () => {
    let data = window.localStorage.getItem(window.defaultAccount) || '[]';
    const transactions = JSON.parse(data);

    transactions.map(item => {
      const { tx, status, showPending } = item;
      if (Number(status) === 1) {
        if (showPending) {
          this.logTransactionPending(item);
        }
        item.checkCnt++;
        getTransactionInfo(tx)
          .then(r => {
            if (r) {
              if (r && r.ret && r.ret[0].contractRet === 'SUCCESS') {
                this.logTransactionConfirmed(item);
              } else if (r && r.ret && r.ret[0].contractRet && r.ret[0].contractRet != 'SUCCESS') {
                this.logTransactionFailed(item);
              } else {
                if (item.checkCnt != undefined && item.checkCnt < 30) {
                  setTimeout(this.checkPendingTransactions, 3000);
                } else {
                  this.logTransactionFailed(item, true); // 90s后的失败的交易直接本地删除
                }
              }
            }
          })
          .catch(ex => {
            // setTimeout(this.checkPendingTransactions, 5000);
            console.error(ex);
          });
      }
      return false;
    });
  };

  logTransactionPending = item => {
    item.showPending = false;
    const { tx, intlObj } = item;
    notification.open({
      key: tx,
      message: intl.get(intlObj.title, intlObj.obj),
      description: this.getDescription(1, item, intl.get('trans_status.pending'))
    });
    this.saveTransactions(item);
  };

  logTransactionConfirmed = item => {
    item.status = 2;
    const { tx, intlObj } = item;
    notification.open({
      key: tx,
      message: intl.get(intlObj && intlObj.title4 ? intlObj.title4 : intlObj.title, intlObj.obj),
      description: this.getDescription(2, item, intl.get('trans_status.confirmed'))
    });
    this.saveTransactions(item);
    if (intlObj.needCallAgain && intlObj.needCallAgain === 'getVoteDetail') {
      this.rootStore.lend.getVoteDetail(intlObj.obj.token);
    }
    // todo 5s后 destroy 这个 key 对应的 notification
  };

  logTransactionFailed = (item, needDelete = false) => {
    item.status = 3;
    const { tx, intlObj } = item;
    notification.open({
      key: tx,
      message: intl.get(intlObj && intlObj.title3 ? intlObj.title3 : intlObj.title, intlObj.obj),
      description: this.getDescription(3, item, intl.get('trans_status.failed')),
      duration: 30
    });
    this.saveTransactions(item, needDelete);
    // 更新localstorage的交易状态
    // todo 5s后 destroy 这个 key 对应的 notification
  };

  saveTransactions = (record, needDelete) => {
    const { tx, status } = record;
    let data = window.localStorage.getItem(window.defaultAccount) || '[]';
    let dataArr = JSON.parse(data);
    let pos = 'true';
    dataArr.map((item, index) => {
      if (item.tx === tx) {
        pos = index;
      }
    });
    if (pos === 'true') {
      return;
    }
    dataArr[pos] = record;
    window.localStorage.setItem(window.defaultAccount, JSON.stringify(dataArr));
  };

  setVariablesInterval = () => {
    if (!this.interval) {
      this.interval = setInterval(async () => {
        try {
          this.checkPendingTransactions();
        } catch (err) {
          console.log('interval error:' + err);
        }
      }, 3000);
    }
  };

  setData = (obj = {}) => {
    const self = this;
    Object.keys(obj).map(key => {
      self[key] = obj[key];
    });
  };

  getNowTime = async () => {
    try {
      let { multyRealStart, multyStart, btcstStart } = this;
      const res = await getTimeNow();
      if (res.success) {
        const nowTime = res.time;
        this.setData({ nowTime });
        window.multyRealStart = multyRealStart;
        window.multyStart = multyStart;

        // btcst start
        if (nowTime < Config.startTime1) {
          btcstStart = false;
        } else if (nowTime >= Config.startTime1) {
          btcstStart = true;
        }
        this.setData({ btcstStart });
        window.btcstStart = btcstStart;
        if (btcstStart) return;
      }
      setTimeout(() => {
        this.getNowTime();
      }, 3000);
    } catch (error) {
      console.log('get time error', error);
      setTimeout(() => {
        this.getNowTime();
      }, 3000);
    }
  };

  getCountTime = async () => {
    if (this.btcstStart) {
      return;
    }
    if (this.nowTime === null) {
      // 如果首次没拿到，需要重新拿
      await this.getNowTime();
    } else {
      this.setData({
        nowTime: this.nowTime + 1000
      });

      let { nowTime, multyRealStart, multyStart } = this;

      // btcst start
      if (nowTime < Config.startTime1) {
        btcstStart = false;
      } else if (nowTime >= Config.startTime1) {
        btcstStart = true;
      }
      this.setData({ btcstStart });
      window.btcstStart = btcstStart;

      // if (nowTime < Config.centuryStart) {
      //   multyStart = false;
      // } else if (nowTime >= Config.centuryStart) {
      //   multyStart = true;
      // }

      // if (nowTime < Config.centuryRealStart) {
      //   multyRealStart = false;
      // } else if (nowTime >= Config.centuryRealStart) {
      //   multyRealStart = true;
      // }

      // this.setData({ multyRealStart, multyStart });
      window.multyRealStart = multyRealStart;
      window.multyStart = multyStart;
    }
    setTimeout(async () => {
      this.getCountTime();
    }, 1000);
  };

  //判断是否有钱包和登录
  checkLogin = () => {
    if (!this.tronWeb || !this.tronWeb.defaultAddress.base58) {
      return false;
    }
    if (!this.defaultAccount) {
      return false;
    }
    return true;
  };

  initTronLinkWallet = async (cb, cbn) => {
    try {
      let timeCount = 0;
      const self = this;
      const tmpTimer1 = setInterval(() => {
        timeCount++;
        if (timeCount > 8) {
          self.isConnected = false;
          cbn && cbn();
          clearInterval(tmpTimer1);
        }
        // tronLink已登录
        if (window.tronWeb && window.tronWeb.ready) {
          if (process.env.REACT_APP_ENV === 'test') {
            window.tronWeb.setFullNode('https://api.nileex.io');
          }
          const { trongrid, chain } = Config;

          if (trongrid && window.tronWeb.setHeader && window.tronWeb.fullNode.host === trongrid.host) {
            // window.tronWeb.setHeader({ 'TRON-PRO-API-KEY': trongrid.key });
          }

          // 不匹配的环境和节点
          if (window.tronWeb.fullNode.host !== chain.fullHost) {
            self.isConnected = false;
            cbn && cbn();
            clearInterval(tmpTimer1);
            if ("foundation.ainft.com" === window.location.host) {
              notification.open({
                key: 'tronLink mainnet',
                message: intl.get('tronlink.node_error'),
                description: intl.get('tronlink.node_error_mainnet_desc'),
              });
            } else {
              notification.open({
                key: 'tronLink testnet',
                message: intl.get('tronlink.node_error'),
                description: intl.get('tronlink.node_error_shasta_desc'),
              });
            }
            return;
          }

          self.tronWeb = window.tronWeb;
          self.defaultAccount = self.tronWeb.defaultAddress.base58;
          window.defaultAccount = self.defaultAccount;
          self.isConnected = true;
          cb && cb();
          this.setVariablesInterval(); // 全局定时任务
          clearInterval(tmpTimer1);
        } else {
          // tronLink未登录
          self.isConnected = false;
          cbn && cbn();
          clearInterval(tmpTimer1);
          notification.open({
            key: 'tronLink not ready',
            message: intl.get('tronlink.not_ready'),
            description: intl.get('tronlink.not_ready_desc'),
          });
        }
      }, 1000);
    } catch (e) {
      console.log(e);
    }
  };

  connectWallet = async () => {
    this.setData({
      loginModalVisible: true,
      loginModalStep: 1
    });
  };

  accountModal = async () => {
    this.setData({
      accountModalVisible: true,
    });
  };

  listenTronLink = () => {
    window.addEventListener('message', res => {
      if (res.data.message && res.data.message.action == 'setAccount') {
        if (window.tronWeb) {
          if (res.data.message.data.address != this.defaultAccount) {
            window.location.reload();
          }
        } else {
          window.location.reload();
        }
      }
      if (res.data.message && res.data.message.action == 'setNode') {
        window.location.reload();
      }
    });
  };

  changeMenuWidth = () => {
    this.setData({
      menuFlag: !this.menuFlag
    });
  };
}
